export const openBooking = (source = "", extra = {}) => {
  window.dispatchEvent(new CustomEvent("open-booking", { detail: { source, ...extra } }));
};
